/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type SegmentStatusEnum =
  (typeof SegmentStatusEnum)[keyof typeof SegmentStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SegmentStatusEnum = {
  NotStarted: 0,
  InProgress: 1,
  Completed: 2,
} as const;
